<template>
  <div class="NewButton">
    <div class="">
    <!-- click button to toggle showing the menu -->
      <button @click.prevent.stop="showMenu = !showMenu"
              class="flex px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-gray-800 hover:bg-gray-500 focus:outline-none focus:border-gray-700 focus:shadow-outline-gray active:bg-gray-700">
        <span class="w-5 h-5 mr-2">
            <IconAdd></IconAdd>
        </span>
        <span>
        <svg class="inline-block h-5 w-5 relative transform rotate-0" fill="currentColor" viewBox="0 0 20 20"
             :class="{'rotate-180': showMenu}">
          <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clip-rule="evenodd"/></svg>
        </span>
      </button>
    </div>
    <div class="origin-top-left absolute z-20 left-0 mt-2 w-auto border border-gray-200 rounded-md shadow-lg"
         :class="{ hidden: !showMenu }">
      <!-- this is the menu-->
      <div class="rounded-md bg-white">
        <div class="py-1">
          <button class="block w-full px-4 py-2 text-left text-sm leading-5 whitespace-no-wrap text-gray-700 hover:bg-gray-200 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                  @click.prevent.stop="$root.$emit('new-price')">New price</button>
          <div class="cursor-not-allowed">
            <button class="pointer-events-none block w-full px-4 py-2 text-left text-sm leading-5 whitespace-no-wrap text-gray-700 hover:bg-gray-200 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                  @click.prevent.stop="$root.$emit('new-folder')">New folder</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import IconAdd from '@/components/icons/IconAdd';

export default {
  name: 'NewButton',
  components: {
    IconAdd
  },
  data() {
    return {
      showMenu: false
    };
  },
  methods: {
    hideMenu: function() {
      this.showMenu = false;
    }
  },
  created: function() {
    window.addEventListener('click', this.hideMenu);
  },
  destroyed: function() {
    window.removeEventListener('click', this.hideMenu);
  },
  mounted() {}
};
</script>
